import { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';
import Head from 'next/head';
import { siteTitle } from '../../../lib/config/project/meta';
import CareersPage from '..';
import { isSkillup } from '../../../lib/config/project/project';
import navGetSSP from '../../../lib/gssp/navGetSSP';

export default function NextPage({
  serverUser,
  serverSeeker,
  query,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  if (isSkillup) {
    return <></>;
  }
  return (
    <>
      <Head>
        <title>{`Career Quiz | ${siteTitle}`}</title>
        <meta
          name="description"
          content="Take a short quiz to discover careers that match your interests in Greater New Orleans."
        />
      </Head>
      <CareersPage
        serverUser={serverUser || (null as any)}
        serverSeeker={serverSeeker || (null as any)}
        query={query}
        quiz={true}
      />
    </>
  );
}
export async function getServerSideProps(ctx: GetServerSidePropsContext) {

 return navGetSSP(ctx);
}
